<ion-app>
  <!-- Global Offline Indicator Banner -->
  <div *ngIf="!networkSyncService.isOnline()" class="global-offline-banner">
    <div class="offline-banner-content">
      <span class="material-symbols-outlined offline-icon">wifi_off</span>
      <span class="offline-text">You are offline &bull; Actions saved locally</span>
    </div>
  </div>

  <!-- Developer Console Neon Micro Edge Grip Trigger -->
  <div *ngIf="allowNetworkDrawer" 
       class="debug-neon-edge-grip" 
       (click)="toggleDrawer()"
       title="Developer Console (Click to open)">
    <div class="grip-body">
      <span class="material-symbols-outlined grip-icon">terminal</span>
      <div class="grip-pills">
        <span class="pill-bar"></span>
        <span class="pill-bar"></span>
      </div>
    </div>
  </div>

  <!-- Right Drawer Backdrop -->
  <div *ngIf="allowNetworkDrawer && isDrawerOpen" class="debug-backdrop" (click)="closeDrawer()"></div>

  <!-- Right Slide-Over Debug Drawer Panel (Compact) -->
  <div *ngIf="allowNetworkDrawer" class="debug-drawer-panel compact" [class.open]="isDrawerOpen">
    <div class="drawer-container">
      <!-- Compact Header -->
      <div class="drawer-header">
        <div class="header-title">
          <span class="material-symbols-outlined title-icon">terminal</span>
          <h3>Debug Console</h3>
        </div>
        <div class="header-right-actions">
          <button class="btn-icon btn-clear" (click)="clearLogs()" title="Clear Logs">
            <span class="material-symbols-outlined">delete_sweep</span>
          </button>
          <button class="btn-close" (click)="closeDrawer()" title="Close Panel">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
      </div>

      <!-- Compact Status & Info Grid -->
      <div class="drawer-quick-info">
        <div class="info-grid">
          <!-- Server Environment -->
          <div class="info-chip server-chip" *ngIf="debugLogger.serverInfo$ | async as server">
            <span class="chip-label">Server</span>
            <span class="chip-badge" [class.live]="server.nodeEnv === 'live'" [class.trust]="server.nodeEnv === 'trust'" [class.shape]="server.nodeEnv === 'shape'">
              {{ (server.nodeEnv || 'unknown') | uppercase }}
            </span>
          </div>

          <!-- Network Status -->
          <div class="info-chip net-chip" [class.offline]="!networkSyncService.isOnline()">
            <span class="chip-label">Network</span>
            <span class="chip-badge">
              {{ networkSyncService.isOnline() ? 'ONLINE (' + (networkSyncService.connectionType() | uppercase) + ')' : 'OFFLINE' }}
            </span>
          </div>

          <!-- Theme Mode Toggle -->
          <div class="info-chip clickable-chip theme-chip" (click)="themeService.toggleTheme()" title="Toggle App Theme">
            <span class="chip-label">Theme</span>
            <span class="chip-btn">
              <span class="material-symbols-outlined chip-icon">{{ themeService.isDark() ? 'dark_mode' : 'light_mode' }}</span>
              {{ themeService.isDark() ? 'Dark' : 'Light' }}
            </span>
          </div>

          <!-- Biometric Lock Toggle -->
          <div class="info-chip clickable-chip bio-chip" (click)="toggleBiometricLock()" title="Toggle Biometric Lock">
            <span class="chip-label">Biometrics</span>
            <span class="chip-btn" [class.active]="biometricAuthService.isBiometricsEnabled()">
              <span class="material-symbols-outlined chip-icon">{{ biometricAuthService.isBiometricsEnabled() ? 'lock' : 'lock_open' }}</span>
              {{ biometricAuthService.isBiometricsEnabled() ? 'Locked' : 'Unlocked' }}
            </span>
          </div>

          <!-- Latest OTP Code -->
          <div class="info-chip otp-chip">
            <span class="chip-label">Latest OTP</span>
            <div class="chip-val-row">
              <span class="otp-text">{{ (debugLogger.latestOtp$ | async) || 'None' }}</span>
              <button *ngIf="latestOtpValue" class="btn-mini-copy" (click)="copyLatestOtp()" title="Copy OTP">
                <span class="material-symbols-outlined copy-icon">content_copy</span>
              </button>
            </div>
          </div>

          <!-- Session / Tenant ID -->
          <div class="info-chip session-chip" *ngIf="sessionController?.session">
            <span class="chip-label">Tenant</span>
            <div class="chip-val-row">
              <span class="tenant-text">{{ sessionController.session?.['x-tenant-id'] || 'No Tenant' }}</span>
              <button class="btn-mini-copy" (click)="copyText(sessionController.session?.token)" title="Copy Token">
                <span class="material-symbols-outlined copy-icon">content_copy</span>
              </button>
            </div>
          </div>

          <!-- Build Info Page Link -->
          <div class="info-chip clickable-chip build-chip" (click)="openBuildInfo()" title="View Build Info">
            <span class="chip-label">Build</span>
            <span class="chip-btn">
              <span class="material-symbols-outlined chip-icon">info</span>
              Details
            </span>
          </div>
        </div>
      </div>

      <!-- Live Stream Header -->
      <div class="drawer-logs-header">
        <span class="logs-count">Logs Stream ({{ (debugLogger.logs$ | async)?.length || 0 }})</span>
      </div>

      <div *ngIf="copiedMessage" class="copy-toast">
        {{ copiedMessage }}
      </div>

      <!-- Live Logs Feed (Compact) -->
      <div class="drawer-logs-list">
        <div *ngFor="let log of (debugLogger.logs$ | async); trackBy: trackByLogId" class="log-item" [ngClass]="log.type">
          <div class="log-item-header">
            <span class="log-type-tag" [ngClass]="log.type">{{ log.type | uppercase }}</span>
            <span class="log-time">{{ log.timestamp }}</span>
            <span *ngIf="log.status" class="log-status" [class.error-status]="log.status >= 400">{{ log.status }}</span>
          </div>
          <div class="log-title">{{ log.title }}</div>
          <pre *ngIf="log.details" class="log-details">{{ log.details | json }}</pre>
        </div>

        <div *ngIf="((debugLogger.logs$ | async)?.length || 0) === 0" class="empty-logs">
          <span><span class="material-symbols-outlined empty-icon">sensors</span> Waiting for API calls & debug errors...</span>
        </div>
      </div>
    </div>
  </div>

  <ion-router-outlet></ion-router-outlet>
</ion-app>